import React, { Component } from 'react'
import { Button, Spin } from 'antd';
import { Link } from 'dva/router'
import { connect } from 'dva'
import moment from 'moment'
import { all } from '../../services/restApi'
import { getTotal, getExcerpt } from '../../utils'
import config from '../../utils/config'
import Currency from 'react-currency-formatter';
var Icon = require('react-fontawesome');
const _ = require('underscore');

class Widget extends Component {

    constructor (props) {
        super(props);

        this.state = {
        	categories: []
        };
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        console.log(this.props);
        this.getTours();
    }


    /**
    * Obtiene los tours
    */
    getTours () {
        this.props.dispatch({type: 'app/showLoadingTable'})

    	all('Category', {
            where: {
                active: true,
                companies: {$in: [{__type: 'Pointer', className: 'TourCompany', objectId: this.props.location.query.widget}]}
            },
            limit: 1000
        }).then((resp) => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            this.setState({ categories: resp.results });
        })
    }



    /**
    * Formulario
    */
    handleSubmit (e) {
    	e.preventDefault();
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <div className="row">
                <Spin spinning={this.props.app.loadingTable}>
                	{this.state.categories.map((item) => (
    	            	<div className="col-md-4 col-sm-6" key={item.objectId}>
    	            		<div className="item-tour">
    	            			<div className="item-tour-cover">
    	            				<Link to="" query={{widget: '123', tour: item.objectId}}>
    		            				<img 
    		            					alt={item.name}
    		            					title={item.name}
    		            					src={
    		            						item.picture 
    		            							? config.externalUrl + 'uploads/activities/' + item.picture 
    		            							: 'https://via.placeholder.com/800/09f/fff?text=' + item.name
    		            					} 
    		            				/>
    		            			</Link>
    	            			</div>

    	            			<div className="item-tour-content">
    	            				<h3 className="item-tour-title">{item.name}</h3>
    	            				<p>{getExcerpt(item.description, 100)}</p>
    	            			</div>

    	            			<div className="item-tour-footer">
    	            				<div className="col-xs-6">
    	            					<Link to="" query={{widget: this.props.location.query.widget, book: item.objectId}}><Icon name="book" /> Reservar</Link>
    	            				</div>
    	            				<div className="col-xs-6">
    	            					<Link to="" query={{widget: this.props.location.query.widget, tour: item.objectId}}><Icon name="plus" /> Leer más</Link>
    	            				</div>
    	            			</div>
    	            		</div>
    	            	</div>
    	            ))}
                </Spin>
            </div>
        )
    }
}

export default connect(({app}) => ({app}))(Widget)


// WEBPACK FOOTER //
// ./src/components/widget/index.js